<!-- SVG Icon Sprite (hidden) -->
<svg xmlns="http://www.w3.org/2000/svg" style="display: none">
  <symbol
    id="gov2-icon-user"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </symbol>
  <symbol
    id="gov2-icon-users"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </symbol>
  <symbol
    id="gov2-icon-office"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </symbol>
  <symbol
    id="gov2-icon-docs"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </symbol>
  <symbol
    id="gov2-icon-contact"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round">
    <path
      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </symbol>
  <symbol
    id="gov2-icon-other"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round">
    <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
    <polyline points="2 17 12 22 22 17"></polyline>
    <polyline points="2 12 12 17 22 12"></polyline>
  </symbol>
</svg>

<div class="gov2-summary-container">
  <div class="summary-wrapper" *ngIf="summary && summary.length > 0">
    <!-- Header -->
    <div *ngIf="hasTitle" class="summary-header">
      <h2 class="header-label">{{ title }}</h2>
    </div>

    <!-- Summary Sections -->
    <div class="summary-sections">
      <ng-container *ngFor="let details of summary; let i = index">
        <!-- Skip DOC type if no documents -->
        <div
          *ngIf="
            !(
              details.type === EDetailsType.DOC &&
              (!documents || documents.length === 0)
            )
          "
          class="summary-section"
          [class.full-width]="
            details.type === EDetailsType.BIG_DETAIL ||
            details.type === EDetailsType.MULTI_APPLICANT ||
            details.title === ESummaryTitle.REPETITIVE_DETAILS ||
            checkRepetitiveComponent(details)
          ">
          <!-- Section Title with Icon -->
          <div class="section-header">
            <div class="section-icon" [ngClass]="getIconClass()">
              <svg width="20" height="20">
                <use
                  [attr.href]="'#gov2-icon-' + getIconId(details.icon)"></use>
              </svg>
            </div>
            <h4 class="section-title">
              {{ formatTitle(details.title) }}
              <span *ngIf="details?.count"> ({{ details.count }})</span>
            </h4>
          </div>

          <!-- Multi Applicants -->
          <ng-container *ngIf="details.type === EDetailsType.MULTI_APPLICANT">
            <div class="multi-applicant-grid">
              <div
                class="applicant-card"
                *ngFor="let detail of details.value; let j = index">
                <h5 class="applicant-title">
                  {{ formatTitle(detail.title) }} ({{ j + 1 }})
                </h5>
                <div class="applicant-data">
                  <p *ngFor="let key of detail.value | keys" class="data-item">
                    <span *ngIf="!!detail.value[key]">
                      {{ formatLabel(key) }} :
                      {{ formatValue(key, detail.value[key]) }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Big Details -->
          <ng-container *ngIf="details.type === EDetailsType.BIG_DETAIL">
            <div class="big-detail-grid">
              <div
                class="big-detail-item"
                *ngFor="let key of details.value | keys; let j = index">
                <p class="detail-label">{{ formatLabel(key) }}</p>
                <div class="detail-value">
                  <span>{{
                    details.value[key]
                      | summary : (showAllIndex !== j ? 120 : 'all')
                  }}</span>
                  <button
                    *ngIf="
                      details.value[key]?.length > 120 && showAllIndex !== j
                    "
                    class="show-more-btn"
                    (click)="toggleSelectedIndex(j)">
                    {{ 'GOV2.show_more' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Land Details -->
          <ng-container *ngIf="details.type === EDetailsType.LAND_DETAIL">
            <div class="section-data">
              <ng-container *ngFor="let key of details.value | keys">
                <p
                  *ngIf="!!details.value[key] && key !== 'land_owners'"
                  class="data-item">
                  {{ formatLabel(key) }} :
                  {{ formatValue(key, details.value[key]) }}
                </p>
                <ng-container *ngIf="key === 'land_owners'">
                  <div
                    *ngFor="let owner of details.value[key]; let j = index"
                    class="owner-card">
                    <p class="sub-header">
                      {{ 'GOV2.owner' | translate }}
                      <span *ngIf="details.value[key]?.length > 1">
                        ({{ j + 1 }})</span
                      >
                    </p>
                    <p class="data-item">
                      {{ 'GOV2.id' | translate }} :
                      {{ owner.identificationNumber }}
                    </p>
                    <p class="data-item">
                      {{ 'GOV2.full_names' | translate }} :
                      {{ owner.fullName }}
                    </p>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>

          <!-- Documents -->
          <ng-container
            *ngIf="
              details.type === EDetailsType.DOC &&
              documents &&
              documents.length > 0
            ">
            <div class="documents-list">
              <div
                *ngFor="let document of documents; let j = index"
                class="document-item">
                <span class="doc-name"
                  >{{ j + 1 }}. {{ formatDocumentName(document) }}:</span
                >
                <span
                  class="doc-link"
                  tabindex="0"
                  (click)="previewAttachment(document)"
                  (keydown.enter)="previewAttachment(document)"
                  >{{ document?.fileName }}</span
                >
              </div>
            </div>
          </ng-container>

          <!-- Repetitive Component (displayFields with JSON table data) -->
          <ng-container *ngIf="checkRepetitiveComponent(details)">
            <div class="section-data">
              <ng-container
                *ngFor="let group of parseRepetitiveGroups(details)">
                <div class="repetitive-table-wrapper">
                  <table class="repetitive-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th *ngFor="let col of group.columns">
                          {{ formatLabel(col) }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of group.rows; let idx = index">
                        <td>{{ idx + 1 }}</td>
                        <td *ngFor="let col of group.columns">
                          {{ formatValue(col, row[col]) }}
                        </td>
                      </tr>
                      <tr *ngIf="group.rows.length === 0">
                        <td
                          [attr.colspan]="group.columns.length + 1"
                          class="empty-table">
                          {{ 'GOV2.no_items' | translate }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- Default/Other Details -->
          <ng-container
            *ngIf="
              details.type !== EDetailsType.BIG_DETAIL &&
              details.type !== EDetailsType.MULTI_APPLICANT &&
              details.type !== EDetailsType.LAND_DETAIL &&
              details.type !== EDetailsType.DOC &&
              details.type !== EDetailsType.LAND_SALE_DETAILS &&
              details.type !== EDetailsType.BUYER_DETAILS &&
              details.type !== EDetailsType.SELLER_DETAILS &&
              details.title !== ESummaryTitle.REPETITIVE_DETAILS &&
              !checkRepetitiveComponent(details)
            ">
            <div class="section-data">
              <!-- Check if this is a location/office section that needs sub-header -->
              <ng-container *ngIf="details.icon === EIconType.OFFICE">
                <p class="sub-header">
                  {{ 'GOV2.processing_office' | translate }}
                </p>
              </ng-container>

              <!-- Simple object display -->
              <ng-container *ngIf="!details.value?.length">
                <ng-container *ngFor="let key of details.value | keys">
                  <ng-container *ngIf="!!details.value[key]">
                    <!-- Check if this should be a bold sub-header -->
                    <ng-container *ngIf="isBoldLabel(key); else normalLabel">
                      <p class="sub-header">{{ formatLabel(key) }}</p>
                      <p class="data-item sub-value">
                        {{ formatValue(key, details.value[key]) }}
                      </p>
                    </ng-container>
                    <ng-template #normalLabel>
                      <p class="data-item">
                        {{ formatLabel(key) }} :
                        {{ formatValue(key, details.value[key]) }}
                      </p>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </ng-container>

              <!-- Array of objects display -->
              <ng-container *ngIf="details.value?.length >= 1">
                <div *ngFor="let obj of details.value" class="nested-section">
                  <p
                    *ngIf="shouldDisplaySectionTitle(details)"
                    class="sub-header">
                    {{ formatLabel(obj.section_title) }}
                  </p>
                  <ng-container *ngFor="let key of obj?.content | keys">
                    <p *ngIf="!!obj.content[key]" class="data-item">
                      {{ formatLabel(key) }} : {{ obj.content[key] }}
                    </p>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!summary || summary.length === 0" class="empty-state">
    <p>No summary data available</p>
  </div>
</div>
